<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil" style="background:#fff;">
            <a-card>
                <div class="search">
                    <a-button type="primary" style="margin-left:14px" @click="addmodal">添加用户</a-button>
                </div>

                  <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                    class="specialtable"
                >
                    <span slot="cumtype" slot-scope="cumtype">
                        <span v-if="cumtype==3">线索计费 点击计费</span>
                        <span v-if="cumtype==2">线索计费</span>
                        <span v-if="cumtype==1">点击计费</span>
                    </span>

                    <span slot="type" slot-scope="type">
                        <span v-if="type==3">员工</span>
                        <span v-if="type==2">企业</span>
                        <span v-if="type==1">平台</span>
                    </span>

                    <span slot="action" slot-scope="text, record">
                        <a-button type="primary" :size="size"  @click="editmodal(index,$event)" :id="record.id"><a-icon type="edit" />编辑</a-button>
                        <a-button type="danger" :size="size" @click="deletemenu(index,$event)" :id="record.id"><a-icon type="delete" />删除</a-button>
                        <a-button type="" @click="rechargemodal(index,$event)" :id="record.id"  :size="size"><a-icon type="pay-circle" />充值</a-button>
                        <a-button type="primary" @click="setshow(index,$event)" :id="record.id"  :size="size"><a-icon type="pay-circle" />价格设置</a-button>
            
                        <a-button v-if="record.type==2" type="primary" @click="domainshow(index,$event)" :id="record.id"  :size="size"><a-icon type="desktop" />域名设置</a-button>
                    </span>
                </a-table>
            </a-card>
        </div>


        <!-- 添加 -->
        <a-modal
            class="pwdmodal"
            title="添加用户"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="rolemodal"
            :confirm-loading="confirmLoading"
            @ok="adduser"
            @cancel="handleCancel"
            >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="username" placeholder="请输入用户名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户密码：</label>
                </a-col>
                <a-col :span="16">
                   <a-input type="password" v-model="password" placeholder="请输入用户密码"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >手机号：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="phone" placeholder="请输入用户手机号"></a-input>
                </a-col>
            </a-row>
            <a-row v-if="type==3">
                <a-col :span="5">
                    <label >所属公司：</label>
                </a-col>
                <a-col :span="16">
                   <a-select v-model="belong" style="width: 120px" @change="addChangecompany">
                        <a-select-option  v-for="pd in companylist" :key="pd.id" v-model="pd.id">
                            {{pd.company}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row>
            <a-row v-if="type!=3">
                <a-col :span="5">
                    <label >公司名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="company" placeholder="请输入公司名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >真实姓名：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="real_name" placeholder="请输入真实姓名"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>昵称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="nick_name" placeholder="请输入用户昵称"></a-input>
                </a-col>
            </a-row>
            <a-row v-if="type!=3">
                <a-col :span="5" >
                    <label>用户角色：</label>
                </a-col>
                <a-col :span="16">
                   <a-select default-value="all" style="width: 120px" @change="handleChange">
                       <a-select-option value="all">
                            --请选择--
                        </a-select-option>
                        <a-select-option  v-for="pd in rolelist" :key="pd.id" v-model="pd.id">
                            {{pd.name}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户类型：</label>
                </a-col>
                <a-col :span="16">
                    <a-radio-group class="ismenu" name="radioGroup" :default-value="3"  @change="editchangeMenu">
                        <a-radio :value="1">
                        平台 
                        </a-radio>
                        <a-radio :value="2">
                        企业
                        </a-radio>
                        <a-radio :value="3">
                        员工
                        </a-radio>
                    </a-radio-group>
                </a-col>
            </a-row>

        </a-modal>

        <!-- 充值 -->
        <a-modal
            class="pwdmodal"
            title="充值"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="czmodal"
            :confirm-loading="confirmLoading"
            @ok="recharge"
            @cancel="handleCancel"
            >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">充值金额：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="money" placeholder="请输入充值金额"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">备注：</label>
                </a-col>
                <a-col :span="16">
                    <a-textarea placeholder="请输入备注（可选）" :rows="4" v-model="remark"/>
                </a-col>
            </a-row>
         </a-modal>

        <!-- 价格设置 -->
        <a-modal
            class="pwdmodal"
            title="价格设置"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="setmodal"
            :confirm-loading="confirmLoading"
            @ok="setprice"
            @cancel="handleCancel"
            >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">计费方式：</label>
                </a-col>
                <a-col :span="16">
                    <a-checkbox-group v-model="defaulcumtype" @change="onChange" style="display:flex" class="cumtype">
                        <a-checkbox value="1">点击付费</a-checkbox>
                        <a-checkbox value="2">线索付费</a-checkbox>
                    </a-checkbox-group>
                </a-col>
            </a-row>
            <a-row :hidden="jfshow">
                <a-col :span="5">
                    <label class="required-icon">点击计费价格：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="click_price" placeholder="请输入点击计费价格"></a-input>
                </a-col>
            </a-row>
            <a-row :hidden="xsshow">
                <a-col :span="5">
                    <label class="required-icon">线索计费价格：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="clew_price" placeholder="请输入线索计费价格"></a-input>
                </a-col>
            </a-row>
         </a-modal>

        <!-- 设置域名 -->
         <a-modal
            class="pwdmodal"
            title="设置域名"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="domainmodal"
            :confirm-loading="confirmLoading"
            @ok="setdomain"
            @cancel="handleCancel"
            >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">站点名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="zdname" placeholder="请输入站点名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">站点域名：</label>
                </a-col>
                <a-col :span="16">
                   <a-textarea placeholder="请输入站点域名（一行一个，回车换行）" :rows="4" v-model="domain"/>
                </a-col>
            </a-row>
         </a-modal>

        <!-- 编辑 -->
        <a-modal
            class="pwdmodal"
            title="编辑用户"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="editrolemodal"
            :confirm-loading="confirmLoading"
            @ok="editrole"
            @cancel="handleCancel"
            >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.username" placeholder="请输入用户名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">用户密码：</label>
                </a-col>
                <a-col :span="16">
                   <a-input type="password" v-model="editinfo.password" placeholder="不填默认不修改"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >手机号：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.phone" placeholder="请输入用户手机号"></a-input>
                </a-col>
            </a-row>
            <a-row v-if="editinfo.type==3">
                <a-col :span="5">
                    <label >所属公司：</label>
                </a-col>
                <a-col :span="16">
                   <a-select v-model="editinfo.belong" style="width: 120px" @change="editChangecompany">
                        <a-select-option  v-for="pd in companylist" :key="pd.id" v-model="pd.id">
                            {{pd.company}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row>
            <a-row  v-if="editinfo.type!=3">
                <a-col :span="5">
                    <label >公司名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.company" placeholder="请输入公司名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >真实姓名：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.real_name" placeholder="请输入真实姓名"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>昵称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.nick_name" placeholder="请输入用户昵称"></a-input>
                </a-col>
            </a-row>
            <a-row v-if="editinfo.type!=3">
                <a-col :span="5">
                    <label>用户角色：</label>
                </a-col>
                <a-col :span="16">
                   <a-select v-model="editinfo.role_id" style="width: 120px" @change="editChange">
                        <a-select-option  v-for="pd in rolelist" :key="pd.id" v-model="pd.id">
                            {{pd.name}}
                        </a-select-option>
                   </a-select>
                </a-col>
            </a-row>
            <a-row v-if="editinfo.type!=3">
                <a-col :span="5">
                    <label class="required-icon">用户类型：</label>
                </a-col>
                <a-col :span="16">
                    <a-radio-group class="ismenu" name="radioGroup" :value="editinfo.type"  @change="changeMenu">
                        <a-radio :value="1">
                        平台 
                        </a-radio>
                        <a-radio :value="2">
                        企业
                        </a-radio>
                        <a-radio :value="3">
                        员工
                        </a-radio>
                    </a-radio-group>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
<style>
tbody tr td:last-of-type{text-align: left !important;}
</style>

<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: '公司名称',
    dataIndex: 'company',
    key: 'company',
  },
  {
    title: '用户类型',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '计费类型',
    dataIndex: 'cumtype',
    key: 'cumtype',
    scopedSlots: { customRender: 'cumtype' },
    width:90
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align:'left',
    rowClassName:'specailtd'
  },
];

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '用户管理'}
            ],
            zdname:"",
            domain:"",
            data:"",
            columns,
            pagination:{},
            loading:false,
            id:"",
            rolemodal:false,
            confirmLoading:false,
            czmodal:false,
            domainmodal:false,
            username:"",
            password:"",
            phone:"",
            real_name:"",
            nick_name:"",
            roleids:"",
            type:3,
            editrolemodal:false,
            rolelist:"",
            editinfo:"",
            size:'small',
            czid:"",
            money:"",
            remark:"",

            setmodal:false,
            click_price:0,
            clew_price:0,
            priceid:"",
            company:"",
            companylist:"",
            belong:"请选择",
            currentpagination:"",

            domainid:"",
            defaulcumtype:['1','2'],
            xsshow:false,
            jfshow:false,
            cumtype:3
        }
    },
    mounted(){
        this.$axios.get('/api/getcompanyList',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.companylist=res.data.data
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){
                this.$message.warning(res.data.msg); 
            }else{
                this.$message.warning(res.data.msg); 
            }
        })

        this.fetch()

        this.$axios.get('/api/getrolelist',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.rolelist=res.data.data.lists
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){
                this.$message.warning(res.data.msg); 
            }else{
                this.$message.warning(res.data.msg); 
            }
        })
    },
    methods:{
        onChange(checkedValues){
         
            if(checkedValues.length==2){
                this.xsshow=false
                this.jfshow=false
                this.cumtype=3
            }else if(checkedValues[0]=="1"){
                this.xsshow=true
                this.jfshow=false
                this.cumtype=1
                this.clew_price=0
            }else if(checkedValues[0]=="2"){
                this.xsshow=false
                this.jfshow=true
                this.cumtype=2
                this.click_price=0
            }else if(checkedValues.length==0){
                this.$message.warning('必须选择一种计费方式'); 
            }
        },
        // 设置域名
        domainshow(index,event){
            var id=event.currentTarget.id
            this.domainid=id
            this.domainmodal=true
            this.$axios.get("/api/domainsetting",{
                 headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    user_id:id
                }
            }).then((res)=>{
                 if(res.data.code==200){
                     this.zdname=res.data.data.name
                     this.domain=res.data.data.domain
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        setdomain(){
            var params=new URLSearchParams()
            params.append('name',this.zdname)
            params.append('domain',this.domain)
            params.append('user_id',this.domainid)
            this.$axios.post('/api/setdomain',params,{
            headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('设置成功'); 
                    this.domainmodal=false
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        handleTableChange(pagination) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.currentpagination=pagination
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
            });
        },

        fetch(params = {}) {
            this.loading = true;
            this.$axios.get('/api/userlist',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        addmodal(){
            this.rolemodal=true
        },
        handleChange(value){
            this.roleids=value
        },
        addChangecompany(){
            this.belong=value
        },
        deletemenu(){
            var editid=event.currentTarget.id
            Modal.confirm({
                title: '提示',
                content: '您确定删除此用户吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(editid)
                },
                onCancel() {

                },
            });
        },
        handok(editid){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/deluser',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==40014){
                    this.$message.warning(res.data.msg); 
                }else if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                }else{
                    this.$message.success(res.data.msg);
                }
            })
        },

        editrole(){
            var params=new URLSearchParams()
            var roleids=this.editinfo.roleids
            if(roleids==undefined){
                roleids=""
            }
            params.append('id',this.editinfo.id)
            params.append('username',this.editinfo.username)
            params.append('password',this.editinfo.password)
            params.append('phone',this.editinfo.phone)
            params.append('real_name',this.editinfo.real_name)
            params.append('nick_name',this.editinfo.nick_name)
            params.append('roleids',roleids)
            params.append('type',this.editinfo.type)
            params.append('company',this.editinfo.company)
            params.append('belong',this.editinfo.belong)
            console.log("token="+localStorage.getItem('token'))
            this.$axios.post('/api/edituser',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('编辑成功'); 
                    this.editrolemodal=false
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        editChange(value){
            this.editinfo.role_id=value
            this.editinfo.roleids=value
        },
        editChangecompany(value){
            this.editinfo.belong=value
        },
        editchangeMenu(e){
            this.type=e.target.value;
        },
        changeMenu(e){
            this.editinfo.type=e.target.value;
        },
        handleCancel(){
            this.rolemodal=false
            this.editrolemodal=false
            this.czmodal=false
            this.setmodal=false
            this.domainmodal=false
        },
        setshow(index,event){
            var editid=event.currentTarget.id
            this.priceid=editid
            var params=new URLSearchParams()
            params.append('user_id',this.priceid)
            this.$axios.post('/api/getrechargesetting',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.setmodal=true
                    this.click_price=res.data.data.click_price
                    this.clew_price=res.data.data.clew_price
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        rechargemodal(index,event){
            this.czmodal=true
            var editid=event.currentTarget.id
            this.czid=editid
        },
        // 编辑角色
        editmodal(index,event){
            this.editrolemodal=true
            var editid=event.currentTarget.id
            this.id=editid
            this.$axios.get('/api/getuserinfo',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:editid
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                    this.editinfo.password=""
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },
        // 价格设置
        setprice(){
            var params=new URLSearchParams()
            params.append('cumtype',this.cumtype)
            params.append('user_id',this.priceid)
            params.append('click_price',this.click_price)
            params.append('clew_price',this.clew_price)
              this.$axios.post('/api/settingrecharge',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('设置成功'); 
                    this.setmodal=false
                }
            })
        },
                    
        recharge(){
            var params=new URLSearchParams()
            params.append('user_id',this.czid)
            params.append('money',this.money)
            params.append('remark',this.remark)
              this.$axios.post('/api/addmoney',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.czmodal=false
                }
            })
        },
        // 添加角色
        adduser(){
            var params=new URLSearchParams()
            var roleids=this.roleids
            if(roleids==undefined){
                roleids=""
            }
            params.append('username',this.username)
            params.append('password',this.password)
            params.append('phone',this.phone)
            params.append('real_name',this.real_name)
            params.append('nick_name',this.nick_name)
            params.append('roleids',roleids)
            params.append('type',this.type)
            params.append('company',this.company)
            params.append('belong',this.belong)
            this.$axios.post('/api/adduser',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('添加成功'); 
                    this.rolemodal=false
                    this.fetch()
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        }
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/index.vue